import React, { FC, useState } from 'react'
import styled, { css } from 'styled-components'

import InfinityObserver from 'components/Observer/InfinityObserver'
import { ISection } from '../../interfaces'
import { IconButton } from '@wirtualna-polska/n2cr-ds'
import { Title } from '../CssStyled'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import Recommendation from './Recommendation'
import { recommendations } from './utils'
import { lng } from '@ads/front-core/locales'

const Recommendations: FC<ISection> = ({ setActiveMenu }) => {
  const [currentSlide, setCurrentSlide] = useState(0)

  const handlePreviousClick = () => {
    setCurrentSlide(
      currentSlide === 0 ? recommendations.length - 1 : currentSlide - 1,
    )
  }

  const handleNextClick = () => {
    setCurrentSlide(
      currentSlide === recommendations.length - 1 ? 0 : currentSlide + 1,
    )
  }

  return (
    <InfinityObserver callback={() => setActiveMenu('benefits')}>
      <Container>
        <TitleWrapper>
          <Title bold>{lng('landing:recommendations')}</Title>
        </TitleWrapper>

        <SliderContainer>
          <SliderButtonPrevious
            name="20-chevron-left"
            onClick={handlePreviousClick}
          />
          <Recommendation
            opinion={recommendations[currentSlide].opinion}
            author={recommendations[currentSlide].author}
          />
          <SliderButtonNext name="20-chevron-right" onClick={handleNextClick} />
        </SliderContainer>

        <Opinions>
          {recommendations.map(opinion => (
            <Recommendation
              key={opinion.author}
              opinion={opinion.opinion}
              author={opinion.author}
            />
          ))}
        </Opinions>
      </Container>
    </InfinityObserver>
  )
}

const Container = styled.div`
  margin: 198px 0 80px;
`

const Opinions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 121px;
  margin: 0 72px 0 96px;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const TitleWrapper = styled.div`
  margin-bottom: 62px;
`

const SliderContainer = styled.div`
  position: relative;
  display: none;
  margin: 0 62px;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: block;
  }
`

const SliderButton = css`
  position: absolute;
  display: none;

  top: 40%;
  transform: translateY(-40%);

  &:active {
    opacity: 1;
  }

  svg {
    width: 40px;
    height: 40px;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    display: block;
  }
`

const SliderButtonPrevious = styled(IconButton)`
  ${SliderButton}
  left: -60px;
`

const SliderButtonNext = styled(IconButton)`
  ${SliderButton}
  right: -60px;
`

export default Recommendations
